import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { HelpIcon } from "../../../../assets/icons/SvgIcons";
import { toolTipConstants } from "../../LexicalEditor.types";

const Help = () => {
  const [show, setShow] = useState(false);
  const [activeTab, setActiveTab] = useState("Handy Shortcuts");

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const tabs = ["Handy Shortcuts"];

  const shortcuts = [
    { action: "Bold", shortcut: "Ctrl + B" },
    { action: "Italic", shortcut: "Ctrl + I" },
    { action: "Underline", shortcut: "Ctrl + U" },
    { action: "Select all", shortcut: "Ctrl + A" },
    { action: "Redo", shortcut: "Ctrl + Y or Ctrl + Shift + Z" },
    { action: "Undo", shortcut: "Ctrl + Z" },
    { action: "Heading 1", shortcut: "Shift + Alt + 1" },
    { action: "Heading 2", shortcut: "Shift + Alt + 2" },
    { action: "Heading 3", shortcut: "Shift + Alt + 3" },
    { action: "Heading 4", shortcut: "Shift + Alt + 4" },
    { action: "Heading 5", shortcut: "Shift + Alt + 5" },
    { action: "Heading 6", shortcut: "Shift + Alt + 6" },
    { action: "Paragraph", shortcut: "Shift + Alt + 7" },
    { action: "Div", shortcut: "Shift + Alt + 8" },
    { action: "Address", shortcut: "Shift + Alt + 9" },
    { action: "Open help dialog", shortcut: "Alt + 0" },
    { action: "Focus to menubar", shortcut: "Alt + F9" },
    { action: "Focus to toolbar", shortcut: "Alt + F10" },
    { action: "Focus to element path", shortcut: "Alt + F11" },
    { action: "Focus to contextual toolbar", shortcut: "Ctrl + F9" },
    { action: "Open popup menu for split buttons", shortcut: "Shift + Enter" },
    { action: "Insert link (if link plugin activated)", shortcut: "Ctrl + K" },
    { action: "Save (if save plugin activated)", shortcut: "Ctrl + S" },
    {
      action: "Find (if searchreplace plugin activated)",
      shortcut: "Ctrl + F",
    },
    {
      action: "Switch to or from fullscreen mode",
      shortcut: "Ctrl + Shift + F",
    },
  ];

  return (
    <>
      <button 
        title={toolTipConstants.help}
        onClick={handleShow} 
        type="button" 
        className="lexical-toolbarItem">
        <HelpIcon />
      </button>
      {show && <div className="lexical-blurOverlay" onClick={handleClose} />}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="lexical-customModal"
      >
        <Modal.Header className="lexical-modalHeader">
          <Modal.Title>Help</Modal.Title>
          <button onClick={handleClose} className="lexical-closeBtn">
            ×
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="lexical-dialogContent">
            <div className="lexical-dialogNav">
              {tabs.map((tab) => (
                <div
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`lexical-navItem ${
                    activeTab === tab ? "lexical-navItemActive" : ""
                  }`}
                >
                  {tab}
                </div>
              ))}
            </div>

            {activeTab === "Handy Shortcuts" ? (
              <div className="lexical-dialogContentTable">
                <table className="lexical-table">
                  <thead>
                    <tr>
                      <th className="lexical-tableHeader">Action</th>
                      <th className="lexical-tableHeader">Shortcut</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shortcuts.map(({ action, shortcut }) => (
                      <tr key={action}>
                        <td className="lexical-tableCell">{action}</td>
                        <td className="lexical-tableCell">{shortcut}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="lexical-dialogPlaceholder"></div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="lexical-modalFooter">
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Help;
